import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../baseQuery';

export interface StudentSlot {
	id: string;
	class: { classNumber: string; section: string };
	periodTemplate: {
		name: string;
		periodNumber: number;
		startTime: string;
		endTime: string;
	} | null;
	dayOfWeek: number;
	dayBucket: string;
	startsAt: string;
	endsAt: string;
	status: 'scheduled' | 'completed' | 'missed';
}

export interface ActiveSessionResponse {
	state: 'no_class' | 'no_active_period' | 'locked' | 'unlocked' | 'completed';
	timezone?: string;
	slot?: {
		id: string;
		periodTemplate: {
			name: string;
			periodNumber: number;
			startTime: string;
			endTime: string;
		} | null;
		startsAt: string;
		endsAt: string;
		className: string;
	};
	curriculum?: {
		id: string;
		moduleIndex: number;
		sessionIndex: number;
	} | null;
	unlockedAt?: string | null;
}

export const studentTimetableApi = createApi({
	reducerPath: 'studentTimetableApi',
	baseQuery: axiosBaseQuery,
	tagTypes: ['StudentWeek', 'StudentActive'],
	endpoints: (builder) => ({
		getStudentWeek: builder.query<
			{
				weekStartDate?: string;
				startDate?: string;
				endDate?: string;
				timezone: string;
				slots: StudentSlot[];
			},
			{ weekStartDate?: string; startDate?: string; endDate?: string }
		>({
			query: ({ weekStartDate, startDate, endDate }) => ({
				url: '/student/timetable/week',
				params: { weekStartDate, startDate, endDate },
			}),
			providesTags: ['StudentWeek'],
		}),
		getActiveSession: builder.query<ActiveSessionResponse, void>({
			query: () => ({ url: '/student/timetable/active-session' }),
			providesTags: ['StudentActive'],
		}),
	}),
});

export const { useGetStudentWeekQuery, useGetActiveSessionQuery } = studentTimetableApi;
